import { animationHelpers } from '@hh/global.js'

const HEADER_OFFSCREEN_BUFFER = 0
export class ProductListStickyNavigation extends HTMLElement {
  connectedCallback() {
    this.isDropdownOpen = false

    if (document.body.classList.contains('dark-theme')) {
      this.classList.add('product-list-sticky-navigation--disabled')
      return
    }

    document.body.classList.add('has-product-list-sticky-navigation')

    this.boundToggleDropdown = this.toggleDropdown.bind(this)
    this.boundHandleToggleKeyboardEvents = this.handleToggleKeyboardEvents.bind(this)
    this.boundHandleInteractOutside = this.handleInteractOutside.bind(this)
    this.boundHandleKeyboardEvents = this.handleKeyboardEvents.bind(this)
    this.boundHandleFocusWhenHidden = this.handleFocusWhenHidden.bind(this)

    this.dropdown = this.querySelector('[data-dropdown]')
    this.dropdownLinks = [...this.dropdown?.querySelectorAll('[data-link]') ?? []]

    this.toggleButton = this.querySelector('[data-list-toggle]')
    this.toggleButton?.addEventListener('click', this.boundToggleDropdown)
    this.toggleButton?.addEventListener('keydown', this.boundHandleToggleKeyboardEvents)
    this.toggleButton?.addEventListener('focus', this.boundHandleFocusWhenHidden)

    document.addEventListener('click', this.boundHandleInteractOutside)
    document.addEventListener('focusin', this.boundHandleInteractOutside)
    window.addEventListener('keydown', this.boundHandleKeyboardEvents)

    this.initHeaderIntersectionObserver()
  }

  disconnectedCallback() {
    if (this.classList.contains('product-list-sticky-navigation--disabled')) {
      return
    }

    this.toggleButton?.removeEventListener('click', this.boundToggleDropdown)
    document.removeEventListener('click', this.boundHandleInteractOutside)
    document.removeEventListener('focusin', this.boundHandleInteractOutside)
    window.removeEventListener('keydown', this.boundHandleKeyboardEvents)
  }

  toggleDropdown(forcedState = null) {
    this.isDropdownOpen = forcedState !== null && typeof forcedState === 'boolean'
      ? forcedState
      : !this.isDropdownOpen

    this.toggleButton?.setAttribute('aria-expanded', `${this.isDropdownOpen}`)
    this.classList.toggle('dropdown-open', this.isDropdownOpen)
  }

  handleInteractOutside(event) {
    const target = event.target
    if (!target) { return }

    const targetIsInSection = this.contains(target)
    if (targetIsInSection) { return }

    this.toggleDropdown(false)
  }

  handleToggleKeyboardEvents(event) {
    if (event.key === 'ArrowUp') {
      event.preventDefault()

      if (this.isDropdownOpen) {
        this.toggleDropdown(false)
        this.toggleButton?.focus()
      } else {
        this.toggleDropdown(true)
        const [firstFocusableElement] = this.dropdownLinks
        firstFocusableElement?.focus()
      }
    }

    if (event.key === 'ArrowDown') {
      event.preventDefault()

      if (this.isDropdownOpen) {
        this.toggleDropdown(false)
        this.toggleButton?.focus()
      } else {
        this.toggleDropdown(true)
        const [lastFocusableElement] = [...this.dropdownLinks].reverse()
        lastFocusableElement?.focus()
      }
    }
  }

  handleKeyboardEvents(event) {
    if (event.key === 'Escape' && this.isDropdownOpen) {
      this.toggleDropdown(false)
      this.toggleButton?.focus()
    }
  }

  handleFocusWhenHidden() {
    if (this.classList.contains('visible')) { return }
    this.toggleDropdown(true)

    const headerWrapper = document.querySelector('[data-header-wrapper]')
    const headerHeight = headerWrapper?.offsetHeight ?? 0
    const scrollTargetY = headerHeight + HEADER_OFFSCREEN_BUFFER + 1
    window.scrollTo({
      top: scrollTargetY,
      behavior: 'smooth'
    })
  }

  initHeaderIntersectionObserver() {
    const header = document.querySelector('[data-main-header]')
    if (!header) { return }

    animationHelpers.createIntersectionObserver(
      header,
      (inView) => {
        this.classList.toggle('visible', !inView)
        if (!inView) {
          this.toggleDropdown(false)
        }
      },
      {
        onlyCallbackOnIntersection: false,
        disableAfterIntersection: false,
        threshold: 0,
        rootMargin: `${HEADER_OFFSCREEN_BUFFER}px 0px 0px 0px`,
      }
    )
  }
}

customElements.define('product-list-sticky-navigation', ProductListStickyNavigation)
